<template>
  <v-container>
    <v-sheet>
      <v-row>
        <div>{{$t('album_form.title')}}</div>
        <div>{{$t('global.text.red_is_required')}}</div>
      </v-row>
      <v-divider></v-divider>

        <v-text-field
          background-color="#F9FAFC"
          v-model="name"
          outlined
          :rules="nameRules"
          :placeholder="$t('albums.table.album_name')"
          required
        ></v-text-field>
        <v-text-field
          background-color="#F9FAFC"
          v-model="publisher"
          outlined
          :rules="nameRules"
          :placeholder="$t('album_form.publisher')"
          required
        ></v-text-field>
        <v-text-field
          background-color="#F9FAFC"
          v-model="editor"
          outlined
          :rules="nameRules"
          :placeholder="$t('album_form.editor')"
          required
        ></v-text-field>

        <v-select
          v-model="selectedAlbum"
          :items="shareScopes"
          :rules="[v => !!v || 'Item is required']"
          :placeholder="$t('album.share_scope')"
          required
          outlined
        ></v-select>

        <v-text-field
          background-color="#F9FAFC"
          v-model="description"
          outlined
          :rules="nameRules"
          :placeholder="$t('album.description')"
          required
        ></v-text-field>
      <v-row>
        <v-btn @click="confirm" flat depressed rounded color="primary">
          <span class="mr-2">{{$t('global.text.btn_confirm')}}</span>
        </v-btn>
        <v-btn @click="cancel" flat depressed rounded>
          <span class="mr-2">{{$t('global.text.btn_cancel')}}</span>
        </v-btn>
      </v-row>
    </v-sheet>
  </v-container>
</template>

<script>
export default {
  name: "AlbumInfoEdit",
  data: function() {
      const currentAlbum = this.$store.getters.currentAlbum;
      const shareScopes = this.commonUtils.getShareScopes(this);
    return {
      name: currentAlbum.data.name,
      publisher: "",
      editor: "",
      shareScopes: shareScopes,

      description: currentAlbum.data.description
    };
  },
  created() {

  },
  computed: {
    albums: function() {
        const albums = this.$store.getters.albums;

            console.log('albums', albums);
        return albums.map(album => {
            return {text: album.data.name, value: album }
        })
    }
  },
  methods: {
      confirm: function() {

      },
      cancel: function() {

      }
  },
};
</script>

<style scoped>
</style>
